"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var json_1 = require("../../../common/helpers/json");
var hours_list_1 = require("../../../common/constants/hours_list");
var minutes_list_1 = require("../../../common/constants/minutes_list");
var InstructorCreateDriveController = /** @class */ (function () {
    function InstructorCreateDriveController($rootScope, $scope, $state, UserService, UsersModel, VehiclesModel, DrivesModel, SchoolsModel, FlashService, BatchCreateService, driveSession, PoliciesModel, $q, instructors, vehicles, instructor, sessionTypes) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.VehiclesModel = VehiclesModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.BatchCreateService = BatchCreateService;
        driveSession.vehicle = vehicles[0];
        driveSession.instructor = instructors.find(function (user) { return user.id === instructor.id; });
        this.driveSession = driveSession;
        this.instructors = instructors;
        this.instructor = instructor;
        this.vehicles = vehicles;
        this.sessiontypes = sessionTypes;
        this.driveSession.type = this.sessiontypes[0];
        if (this.driveSession.type.hidden === true) {
            this.driveSession.private = "Y";
        }
        BatchCreateService.setDrive(this.driveSession);
        this.zones = [];
        this.sectors = [];
        this.policies = {};
        this.batchDupeDrive = "N";
        this.overrideInstructorSettings = "N";
        this.hoursList = hours_list_1.hours_list;
        this.minutesList = minutes_list_1.minutes_list;
        this.currentUser = UserService.getCurrentUser();
        this.loading = true;
        this.use_service_area = false;
        this.handleDatepickerChange = this.handleDatepickerChange.bind(this);
        $rootScope.$on("MESSAGE_CLEARED", function () {
            _this.submitted = false;
        });
        // load all of the things!
        var getSchool = SchoolsModel.getSchoolByID(this.currentUser.school_id);
        var getPolicies = PoliciesModel.getAll();
        $q.all([getSchool, getPolicies]).then(function (responses) {
            // Process policies FIRST to set use_service_area flag
            _this.formatPoliciesResponse(responses[1]);
            // THEN process school data which depends on the flag
            _this.formatSchoolResponse(responses[0]);
            _this.loading = false;
        });
    }
    InstructorCreateDriveController.prototype.formatPoliciesResponse = function (response) {
        var _this = this;
        response.policies.forEach(function (policy) {
            var policyName = policy.name;
            _this.policies[policyName] = { id: policy.id, policymeta: {} };
            var policyMeta = {};
            policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            _this.policies[policyName].policymeta = policyMeta;
        });
        if (this.policies.drives.policymeta.minimum_session_length) {
            var dur = (0, time_1.minutesToHoursAndMinutes)(this.policies.drives.policymeta.minimum_session_length);
            this.driveSession.length.hours = dur.hours;
            this.driveSession.length.minutes = dur.minutes;
        }
        if (this.policies.drives.policymeta.use_service_area === "Y") {
            this.use_service_area = true;
        }
        else {
            this.use_service_area = false;
        }
        setTimeout(function () {
            _this.hasSectors = false;
        }, 300);
    };
    InstructorCreateDriveController.prototype.formatSchoolResponse = function (response) {
        var _this = this;
        this.school = response;
        // When service areas are disabled, locations may have empty zones/zoneparts
        // Only filter if we're using service areas; otherwise use all locations
        var availableLocations;
        if (this.use_service_area) {
            availableLocations = response.locations.filter(function (location) {
                return location.zoneparts && location.zoneparts.length > 0;
            });
        }
        else {
            availableLocations = response.locations;
        }
        // Handle case where no locations are available
        if (availableLocations.length === 0) {
            this.driveSession.location = null;
            this.zones = [];
            this.sectors = [];
            return;
        }
        this.driveSession.location = availableLocations[0];
        // Safely map zones and sectors
        this.zones = (this.driveSession.location.zones || []).map(function (zone) { return ({
            id: zone.id,
            name: zone.name,
        }); });
        this.sectors = (this.driveSession.location.zoneparts || []).map(function (sector) { return ({
            id: sector.id,
            name: sector.name,
            zone_id: sector.zone_id,
        }); });
        // Pre-select zones/sectors for instructor
        this.zones.forEach(function (zone, index) {
            if (_this.instructorInZone(zone)) {
                _this.driveSession.zones[index] = zone;
            }
        });
        this.sectors.forEach(function (sector, index) {
            if (_this.instructorInSector(sector)) {
                _this.driveSession.sectors[index] = _this.sectors[index];
            }
        });
    };
    InstructorCreateDriveController.prototype.zoneSelected = function (zone) {
        var _this = this;
        // get array of selected zone ids
        var zoneSelected = this.driveSession.zones.filter(function (z) {
            if (z === null) {
                return false;
            }
            return z.id === zone.id;
        }).length > 0;
        if (zoneSelected) {
            // add all sectors of zone
            this.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.driveSession.sectors[index] = sector;
                }
            });
        }
        else {
            // remove all sectors of zone
            this.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    delete _this.driveSession.sectors[index];
                }
            });
        }
    };
    InstructorCreateDriveController.prototype.instructorInSector = function (sector) {
        var instructorZoneparts = this.instructor.zoneparts || [];
        var instructorSectorIds = instructorZoneparts.map(function (s) { return s.id; });
        return instructorSectorIds.includes(sector.id);
    };
    InstructorCreateDriveController.prototype.instructorInZone = function (zone) {
        var instructorZones = this.instructor.zones || [];
        var instructorZoneIds = instructorZones.map(function (z) { return z.id; });
        return instructorZoneIds.includes(zone.id);
    };
    InstructorCreateDriveController.prototype.sectorSelected = function (sector) {
        var _this = this;
        // is our sector selected?
        var sectorSelected = this.driveSession.sectors.filter(function (s) {
            if (s === null) {
                return false;
            }
            return s.id === sector.id;
        }).length > 0;
        if (sectorSelected) {
            // add the sector's zone
            this.zones.forEach(function (zone, index) {
                if (sector.zone_id === zone.id) {
                    _this.driveSession.zones[index] = zone;
                }
            });
        }
        else {
            // remove the sector's zone
            this.zones.forEach(function (zone, index) {
                // are there no selected sectors in this zone?
                var zoneSelected = _this.driveSession.sectors.filter(function (s) {
                    if (s === null) {
                        return false;
                    }
                    return s.zone_id === zone.id;
                }).length > 0;
                // if not deselect the zone
                if (zoneSelected === false) {
                    delete _this.driveSession.zones[index];
                }
            });
        }
    };
    InstructorCreateDriveController.prototype.updateSessionTypeDefault = function () {
        var _a;
        if (((_a = this.driveSession.type) === null || _a === void 0 ? void 0 : _a.hidden) === true) {
            this.driveSession.private = "Y";
        }
        else {
            this.driveSession.private = "N";
        }
    };
    InstructorCreateDriveController.prototype.noteLengthValid = function () {
        if (typeof this.driveSession.notes === "undefined") {
            return true;
        }
        return this.driveSession.notes.length <= 500;
    };
    InstructorCreateDriveController.prototype.clearForm = function () {
        this.driveSession.sectors = [];
        this.driveSession.vehicle = null;
    };
    InstructorCreateDriveController.prototype.updateSessionForm = function () {
        var _this = this;
        this.hasSectors = false;
        if (!this.driveSession.location) {
            this.zones = [];
            this.sectors = [];
            return;
        }
        this.zones = (this.driveSession.location.zones || []).map(function (zone) { return ({
            id: zone.id,
            name: zone.name,
        }); });
        this.zones.forEach(function (zone, index) {
            _this.driveSession.zones[index] = zone;
        });
        this.sectors = (this.driveSession.location.zoneparts || []).map(function (sector) { return ({
            id: sector.id,
            name: sector.name,
            zone_id: sector.zone_id,
        }); });
        this.sectors.forEach(function (sector, index) {
            _this.driveSession.sectors[index] = _this.sectors[index];
        });
    };
    InstructorCreateDriveController.prototype.updateSessionDate = function (newDate) {
        this.driveSession.date = newDate.selected[0];
    };
    InstructorCreateDriveController.prototype.updateSessionTime = function (newTime) {
        this.driveSession.time = newTime.selected[0];
    };
    InstructorCreateDriveController.prototype.handleDatepickerChange = function (newDatetime) {
        if (newDatetime.pickerType === "time") {
            this.updateSessionTime(newDatetime);
        }
        else if (newDatetime.pickerType === "date") {
            this.updateSessionDate(newDatetime);
        }
    };
    InstructorCreateDriveController.prototype.processSession = function () {
        var _this = this;
        var _a;
        this.submitted = true;
        var session = Object.assign({}, this.driveSession);
        if (session.hasOwnProperty("sectors")) {
            session.sectors = session.sectors
                .filter(function (sector) { return sector !== null; })
                .map(function (sector) {
                delete sector.geom;
                return sector;
            });
        }
        if (session.hasOwnProperty("zones")) {
            delete session.zones;
        }
        session.location = { id: session.location.id };
        session.instructor = { id: session.instructor.id };
        session.formatTime = (0, time_1.formatDateTime)(this.driveSession.time, "HH:mm:ss");
        session.formatDate = (0, time_1.formatDateTime)(this.driveSession.date, "YYYY-MM-DD");
        session.override_instructor_settings = this.overrideInstructorSettings;
        if (((_a = session.vehicle) === null || _a === void 0 ? void 0 : _a.id) === 0) {
            delete session.vehicle;
        }
        if (this.use_service_area === false) {
            delete session.location;
            delete session.zoneparts;
            delete session.sectors;
            delete session.zones;
        }
        this.DrivesModel.createDrive(session)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.driveSession = {
                length: {},
                sectors: [],
                zones: [],
                private: "N",
                observation: false,
                vehicle: null,
                instructor: null,
                type: null,
                location: null,
                date: null,
                time: null,
            };
            _this.submitted = false;
            _this.$state.go("drivecoach.instructor.dashboard", {}, { reload: true });
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return InstructorCreateDriveController;
}());
InstructorCreateDriveController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "UserService",
    "UsersModel",
    "VehiclesModel",
    "DrivesModel",
    "SchoolsModel",
    "FlashService",
    "BatchCreateService",
    "driveSession",
    "PoliciesModel",
    "$q",
    "instructors",
    "vehicles",
    "instructor",
    "sessionTypes",
];
exports.default = InstructorCreateDriveController;
